import _axios from '@/assets/utils/_axios'
import Router from '@/router'
import {_loading} from '../../assets/utils/utils'
import HotLetterCity from '@/assets/utils/HotLetterCity.json'             //城市信息
import { data } from 'jquery';

export default {
  //获取酒店活动列表
  async GetActivityList({commit, getters}, data) {
    //全部订单状态值重新处理
    let loading = _loading({target: '#activity_list'});
    let res = await _axios.post('/pc/AuthAndBind/getOnSaleHotel', {
      store_id: getters.storeInfo.storeId,
      ...data,
    });
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let activityList = res.data ? res.data : [];
      let total = res.num ? res.num : 0;
      let expired = res.over ? res.over : 0;
      let underway = res.noOver ? res.noOver : 0;
      commit('UPDATEACTIVITYLIST', activityList);
      commit('UPDATEEXPIREDACT', expired);
      commit('UPDATEUDERWAYACT', underway);
      commit('UPDATETOTALACT', total);
    }
  },

  //获取酒店活动列表详情
  async GetActivityDetail({commit, getters}, data) {
    let loading = _loading({target: '#activity_detail'});
    let res = await _axios.post('/pc/AuthAndBind/getHotelActiveDetail', {...data});
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let activityDetail = res.data;
      commit('UPDATEHOTELACTIVITIES', activityDetail);
    }
  },

  //酒店，民宿，景区搜索结果
  async GetHotelList({commit, getters}, {type, data,el = '#result_list'}) {
    let loading = _loading({target: el});
    let url;
    switch (type) {
      case 'homestay':
        url = '/pc/AuthAndBind/getHomestayList';
        break;
      case 'hotel':
        url = '/pc/Home/HotelList';
        break;
      case 'scenic':
        url = '/pc/AuthAndBind/getViewpointList';
        break;
      case 'product':
        url = '/pc/AuthAndBind/getProductList';
        break;
      case 'brand':
        url = '/pc/AuthAndBind/getItineraryData';
        break;
    }
    let datas = {
      store_id: getters.storeInfo.storeId,
      ...data,
    }
    if (type == 'brand') { delete datas.store_id; datas.isGetRoomcal = '1' }
    let res = await _axios.post(url, datas);
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let total = res.data.count ||res.data.count|| 0;
      let showTotal = res.showCount ||res.data.showCount||  0;
      let hotelList = res.data.list || [];
      let hotelRight = res.hotelRight || res.homestayRight || res.viewpointRight || res.hot|| res.data.hotelRightHot|| [{}];
      let hotelRightNew = res.data.hotelRightNew || [{}];
      let hotelOther = res.hotel_other || res.homestay_hot || res.viewpoint_hot || res.hot || [{}];
      let brandInfo = res.head ||{}
      commit('UPDATETOTALACCOUNT', total);
      commit('UPDATESEARCHEDTOTAL', showTotal);
      commit('UPDATEHOTELLIST', hotelList);
      commit('UPDATERIGHTADVERTIE', hotelRight);
      commit('UPDATEHOTELRIGHTNEW', hotelRightNew);
      commit('UPDATEHOTHOTEL', hotelOther);
      commit('UPDATEBRANDINFO',brandInfo)
      if (type == 'brand') commit('UPDATECOMMENTINFO', res.comment || {});
    }
  },

  //获取酒店、景区、民宿的首字母
  async GetInitialList({commit, getters}, {type,el}) {
    let loading = _loading({target: el});
    let url = '';
    switch (type) {
      case 'hotel':
        url = '/pc/Visitor/getHotelFirst';
        break;
      case 'homestay':
        url = '/pc/AuthAndBind/getHomestayFirst';
        break;
      default:
        break;
    }
    let res = await _axios.post(url, {needType:1});
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let titleInitial = res.data;
      commit('UPDATESEARCHINITIAL', titleInitial);
    }
  },
    //获取详情页酒店、景区、民宿的详情
  async GetDisplayInfo({commit, getters}, {type, data,successFun}) {
    // let loading = _loading({target: '#display_title'});
    let url;
    switch (type) {
      case '3':
        url = '/pc/Home/HotelDetail';
        break;
    }
    let res = await _axios.post(url, {...data});
    // loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let basicInfo =  res.data.info;
      let roomImgArr = [];    //房间图片总数组
      let meetImgArr = [];    //会议室图片数组
      let totallength=0;      //所有图片总数
      //拼接7张主图判断是否有房型
      if(basicInfo.room_arr.length>0){
          basicInfo.room_arr.forEach(m => { m.pic = m.pic.split(',');roomImgArr.push(...m.pic)});
          //有7张主图则删除后3张合并房间图片
          if(basicInfo.pic_arr.length==7){
            basicInfo.pic_arr.splice(4, roomImgArr.length<3?3:roomImgArr.length);
          }
          basicInfo.pic_arr.push(...roomImgArr);
      }
      //会议室图片数组
      basicInfo.meeting_arr.forEach(m => { m.pic = m.pic.split(',');meetImgArr.push(...m.pic)});
      totallength+=roomImgArr.length;
      totallength+=meetImgArr.length;
      //处理图片数组
      const picFields = [
        {name:'外观',key:'pic',icon:'icon-jiudian1'},
        {name:'内景',key:'interior_pic',icon:'icon-jingdian1'},
        {name:'大堂',key:'pic_lobby',icon:'icon-icon_datangba'},
        {name:'公共',key:'pic_common',icon:'icon-gonggongquyu'},
        {name:'餐厅',key:'pic_eatery',icon:'icon-zhuyecanting'},
        {name:'休闲康乐',key:'pic_rest',icon:'icon-shenghuoxiuxian'},
        {name:'其他配套',key:'pic_other',icon:'icon-qitafuwu'},
      ];
      // 循环处理每个字段
      picFields.forEach(field => {
        // 确保字段存在且为字符串，避免 split 报错
        if (typeof basicInfo[field.key] === 'string'&&basicInfo[field.key]!='') {
            field.img= basicInfo[field.key].split(',');
        } else {
            // 处理非字符串情况（如 undefined 或 null），避免后续使用出错
            field.img= [];
        }
        totallength+=field.img.length;
      });
      picFields.splice(2, 0, {name:'房型',key:'room_arr',img:roomImgArr,icon:'icon-fangjian1'}, {name:'会议室',key:'meeting_arr',img:meetImgArr,icon:'icon-huiyi'});
      basicInfo.photoAlbum=picFields;
      basicInfo.totallength=totallength;
      basicInfo.roomImgArr=roomImgArr;
      basicInfo.meetImgArr=meetImgArr;
      basicInfo.meetingNum=basicInfo.meeting_arr.length ||0;   //会议室数量
      basicInfo.breakfast_type=basicInfo.breakfast_type.split(',') ||[];   //早餐时间
      successFun(basicInfo);  
      commit('UPDATEBASICINFO', basicInfo);
    }
  },
  // //获取详情页酒店、景区、民宿的详情
  // async GetDisplayInfo({commit, getters}, {type, data,successFun}) {
  //   // let loading = _loading({target: '#display_title'});
  //   let url;
  //   switch (type) {
  //     case '3':
  //       url = '/pc/Home/HotelDetail';
  //       data.store_id=data.id;
  //       delete data.id;
  //       break;
  //     case '5':
  //       url = '/pc/AuthAndBind/getHomestayDetail';
  //       data.homestay_id = data.id;
  //       delete data.id;
  //       break;
  //     case '6':
  //       url = '/pc/AuthAndBind/getViewpointDetail';
  //       data.viewpoint_id = data.id;
  //       delete data.id;
  //       break;
  //     case '7':
  //       url = '/pc/AuthAndBind/getProductDetail';
  //       data.product_id = data.id;
  //       delete data.id;
  //       break;
  //     case '8':
  //       url = '/pc/AuthAndBind/getItineraryData';
  //       data.brandhall_id = 1;
  //       delete data.id;
  //       break
  //     default:
  //       return {};
  //   }
  //   let res = await _axios.post(url, {...data});
  //   // loading.close();
  //   if (res.code === '00000' || res.code === '99999') {
  //     let basicInfo = res.hotel || res.data.info||res.head || res.info || res.data;
  //     let roomType = res.roomType || [];
  //     let scenicTickets = [];
  //     basicInfo.pic = basicInfo.pic.split(',').map(item => { 
  //       return {
  //         picture: item,
  //         title: '酒店内景图'
  //       }
  //     });
  //     basicInfo.pic_lobby = basicInfo.pic_lobby.split(',').map(item => { 
  //       return {
  //         picture: item,
  //         title: '酒店外景图'
  //       }
  //     });
  //     if (type === '6') {
  //       basicInfo.mobile = res.mobile
  //       basicInfo.open_hours = basicInfo.open_hours.replace('/azhou/', '，');
  //       basicInfo.picture = basicInfo.pic.map(item => {
  //         return {
  //           picture: item,
  //           title: '景区外观图'
  //         }
  //       });
  //       scenicTickets = res.ticket;          //景区门票
  //     }
  //     if (type === '7') {
  //       basicInfo.picture = basicInfo.picture.map(item => { 
  //         return {
  //           picture: item,
  //           title: '度假产品外观图'
  //         }
  //       });
  //       basicInfo.hot = res.hot || [];
  //     }
  //     let calendarInfo = res.calendary || [];
  //     let commentInfo = res.comment || {};
  //     let meetInfo = basicInfo.meeting_arr || res.meeting || [];
  //     let rangeInfo = res.range;
  //     let roomInfo = basicInfo.room_arr || [];
  //     let actiInfo = res.onsale || [];
  //     let raryInfo = res.itinerary || [];
  //     let restaurantInfo = res.restaurant || [];
  //     roomInfo.forEach(m => { m.pic = m.pic.split(','); m.badge = 0 })
  //     meetInfo.forEach(m => { m.pic = m.pic.split(','); m.badge = 0 })
  //     if (type == 3) commit('UPDATEACTIINFO', actiInfo);
  //     if (type == 8) {
  //       actiInfo.forEach(m => { m.pic = m.pic.split(','); m.badge = 0 })
  //       raryInfo.forEach(m => { m.pic = m.pic.split(','); m.badge = 0 })
  //       restaurantInfo.forEach(m => { m.pic = m.pic.split(','); m.badge = 0 })
  //       commit('UPDATEACTIINFO', actiInfo);
  //       commit('UPDATERARYINFO', raryInfo);
  //       commit('UPDATERESTAURANTINFO', restaurantInfo);
  //     }
  //     let homestayActi = res.homestayOnsale || [];
  //     homestayActi.forEach(item => {
  //         item.pic = item.pic.split(',');
  //         if (item.detail) {
  //           item.detail.forEach(priceItem => {
  //             priceItem.productNum = priceItem.min_nums;
  //           })
  //         }
  //       });
  //     let rangeHotel = res.data.hotelRightRange;
  //     let hotelRightSameStar = res.data.hotelRightSameStar;
  //     let nearHotHotel = res.promote ? res.promote.homeHotelOther : [];
  //     let nearHotHomestay = res.promote ? res.promote.homestayHot : [];
  //     let shopCart = {};
  //     if (res.shopcart && res.shopcart.date_in) {
  //       shopCart = res.shopcart;
  //     }
  //     commit('UPDATEBASICINFO', basicInfo);
  //     successFun(basicInfo);
  //     commit('UPDATEROOMTYPE', roomType);
  //     if (!Router.currentRoute.path.includes('hotel_detail')) commit('UPDATECALENDARINFO', calendarInfo);
  //     commit('UPDATECOMMENTINFO', commentInfo);
  //     commit('UPDATEMEETINFO', meetInfo);
  //     commit('UPDATERANGEINFO', rangeInfo);
  //     commit('UPDATEROOMINFO', roomInfo);
  //     commit('UPDATEHOMESTAYACT', homestayActi);
  //     commit('UPDATENEARHOTEL', nearHotHotel);
  //     commit('UPDATESCENICTICKET', scenicTickets);
  //     commit('UPDATENEARHOTHOMESTAY', nearHotHomestay);
  //     commit('UPDATERANGEHOTEL', rangeHotel);
  //     commit('UPDATEPEERHOTEL', hotelRightSameStar);
  //     commit('UPDATESHOPTIME', shopCart);
  //   }
  // },

  //获取不同等级的评论
  async CommentsByRate({commit, getters}, data) {
    return
    let loading = _loading({target: '#comment_display'});
    let res = await _axios.post('/pc/AuthAndBind/getHotelCommentList', {...data});
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let totalAccount = res.total_nums || 0;
      let commentList = res.info || [];
      /*el-rate组件分值绑定需要数值类型*/
      commentList.forEach(item => {
        item.hotel_equally = Math.round(item.hotel_equally * 10) / 10
      });
      commit('UPDATECOMMENTNUM', totalAccount);
      commit('UPDATECOMMENTLIST', commentList);
    }
  },

  //收藏酒店/取消收藏
  async CollectionOperate({commit, getters}, {flag, data, successFun}) {
    let url;
    if (flag) url = '/pc/AuthAndBind/travelFav';
    else url = '/pc/AuthAndBind/travelCancelFav';
    let res = await _axios.post(url, {...data});
    if (res.code === '00000') successFun();
  },

  //按月份获取酒店价格
  async GetRoomCalendar({commit, getters}, data) {
    let url = '/pc/AuthAndBind/getItineraryRoomData'
    if (Router.currentRoute.path.includes('brand')) url = '/pc/AuthAndBind/getItineraryRoomData'
    let res = await _axios.post(url, {...data});
    if (res.code === '00000') {
      let renowCalendar = res.data || res.info || [];
      commit('UPDATECALENDARINFO',   renowCalendar);
    }
  },

  //按日期获取酒店所有房型价格
  async GetCalAllRooms({commit, getters}, {data,successFun}) {
    let res = await _axios.post('pc/AuthAndBind/getHotelRoomcal', {...data});
    if (res.code === '00000') { successFun(res) }
  },

  // //详情页=》获取同级别的酒店
  // async GetPeerHotel({commit, getters}, data) {
  //   let loading = _loading({target: '#peer_hoel'});
  //   let res = await _axios.post('/pc/AuthAndBind/getHotelRangeLevel', {...data});
  //   loading.close();
  //   if (res.code === '00000' || res.code === '99999') {
  //     let peerHotel = res.data || [];
  //     commit('UPDATEPEERHOTEL', peerHotel);
  //   }
  // },

  //采购商将民宿房间或活动添加到购物车
  async AddShopCart({commit, getters}, {data, successFun}) {
    let loading = _loading({target: '#tabRooms'});
    let res = await _axios.post('/pc/Travel/addHomestayToShopCart', {...data});
    loading.close();
    if (res.code === '00000') successFun();
  },

  //获取购物车信息
  async GetShopCartInfo({commit, getters}, data) {
    let loading = _loading({target: '#shop_cart'});
    let res = await _axios.post('/pc/Travel/showShopCart', {
      store_id: getters.isGroup ? Router.currentRoute.query.storeId : getters.storeInfo.storeId,
      ...data
    });
    loading.close();
    if (res.code === '00000') {
      let shopNameInfo = res.homestayInfo || '';
      let roomArr = res.info.room || [];
      if (roomArr.length > 0) roomArr.forEach(item => item.deleteVisible = false);
      let actiArr = res.info.sale || [];
      if (actiArr.length > 0) actiArr.forEach(item => {
        item.deleteVisible = false;
      });
      let travelInfo = res.info.contact || '';
      let nightNum = (shopNameInfo.date_out - shopNameInfo.date_in) / 86400;
      commit('UPDATESHOPTARGETINFO', shopNameInfo);
      commit('UPDATESHOPROOMARR', roomArr);
      commit('UPDATESHOPACTISARR', actiArr);
      commit('UPDATESHOPTRAVELINFO', travelInfo);
      commit('UPDATESTAYNIGHTNFO', nightNum);
    }
    if (res.code === '99999') {
      let shopNameInfo = '';
      let roomArr = [];
      let actiArr = [];
      let travelInfo = '';
      let nightNum = false;
      commit('UPDATESHOPTARGETINFO', shopNameInfo);
      commit('UPDATESHOPROOMARR', roomArr);
      commit('UPDATESHOPACTISARR', actiArr);
      commit('UPDATESHOPTRAVELINFO', travelInfo);
      commit('UPDATESTAYNIGHTNFO', nightNum);
    }
  },

  //清空购物车
  async EmptyShopCart({commit, getters}, {shopcartId, successFun}) {
    let loading = _loading({target: '#empty_cart'});
    let res = await _axios.post('/pc/Travel/emptyShopcart', {shopcartId: shopcartId});
    loading.close();
    if (res.code === '00000') successFun();
  },

  //修改购物车数量
  async EditShopNum({commit, getters}, data) {
    let res = await _axios.post('/pc/Travel/editShopCart', {...data});
    if (res.code === '00000') {
      return res.info;
    }
  },

  //删除购物车某一数据
  async DeleteShopCart({commit, getters}, {shopcartId, successFun}) {
    let res = await _axios.post('/pc/Travel/delShopCart', {shopcartId: shopcartId});
    if (res.code === '00000') successFun();
  },

  //购物车提交
  async SubmitShopCart({commit, getters}, {data, successFun}) {
    let loading = _loading({target: '#shopcart_info'});
    let res = await _axios.post('/pc/Travel/homestayConfirm', {...data});
    loading.close();
    if (res.code === '00000') successFun();
  },

  //获取某一城市下的行政区划信息
  async GetCityBlocks({commit, getters}, data) {
    let loading = _loading({target: '#get_blocks'});
    let res = await _axios.post('/pc/AuthAndBind/getDistrictByCity', {...data});
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let blockConditionLists = res.data;
      commit('UPDATEBLOCKLIST', blockConditionLists);
    }
  },

  //获取景区门票
  async ScenicTickets({commit, getter}, data) {
    let res = await _axios.post('/pc/AuthAndBind/getViewpointTickets', {...data});
    if (res.code === '00000') {
      let otherTickets = res.info;
      commit('UPDATESCENICOPTIONS', otherTickets);
    }
  },

  //提交景区团队门票订单
  async ScenicGroupReserve({commit, getters}, {data, successFun}) {
    let type = getters.storeInfo.type
    let loading = _loading({target: '#group_ticket'});
    let url
    if (type == 2) url = '/pc/Travel/submitViewpointTeamOrder'
    else url = '/pc/Common/submitViewpointTeamOrder'
    let res = await _axios.post(url, {...data});
    loading.close();
    if (res.code === '00000') successFun(res);
  },

  //提交景区散客门票订单
  async ScenicIndiviReserve({commit, getters}, {data}) {
    let type = getters.storeInfo.type
    let loading = _loading({target: '#individual_ticket'});
    let url
    if (type == 2) url = '/pc/Travel/submitViewpointOrder'
    else url = '/pc/Common/submitViewpointOrder'
    let res = await _axios.post(url, {...data});
    loading.close();
    if (res.code === '00000') {
      let routerId = res.data;
      commit('UPDATESCENICROUTER',routerId);
    }
  },
  //提交度假产品订单
  async postProductOrder({commit, getters}, data) {
    let loading = _loading({target: '#individual_ticket'});
    let res = await _axios.post('/pc/Common/submitProductOrder', {
      store_id:getters.isGroup ? Router.currentRoute.query.storeId : getters.storeInfo.storeId,
      ...data
    });
    loading.close();
    if (res.code === '00000') return res.data
  },
  //获取酒店/民宿/景区地图信息
  async GetMapInfo({commit, getters}, {data, type}) {
    let loading = _loading({target:'#display_map'});
    let url;
    switch (type) {
      case '3':
        url = '/pc/Home/MapHotelList';
        break;
      case '5':
        url = '/pc/AuthAndBind/getHomestayListByMap';
        break;
      case '6':
        url = '/pc/AuthAndBind/getViewPointListByMap';
        break;
      default:
        url = '';
        break;
    }
    let res = await _axios.post('/pc/Home/MapHotelList', {...data,needType:1});
    loading.close();
    if (res.code === '00000' || '99999') {
      let basicInfo = res.data.list || [];
      commit('UPDATEBASICMAP',basicInfo);
    }
  },

  //地图搜索页获取所有的城市列表
  async GetCityList({commit, getters}) {
    // let res = await _axios.post('/pc/AuthAndBind/getAllCity',{});
    let res=HotLetterCity;
    let hotCity = res.hot || [];
    let cityInitial = [];
    for (let key in res.info) {
      cityInitial.push({
        letter:key,
        values:res.info[key],
      })
    }
    commit('UPDATEHOTCITY',hotCity);
    commit('UPDATETCITYINITIAL',cityInitial);
    // if (res.code === '00000') {

    // }
  }
}
